import { render, staticRenderFns } from "./Malerei.vue?vue&type=template&id=cac45352&scoped=true&"
import script from "./Malerei.vue?vue&type=script&lang=js&"
export * from "./Malerei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac45352",
  null
  
)

export default component.exports